
import './preferences.css';

import angular from 'angular';
import uirouter from 'angular-ui-router';

import brand from '../../service/brand';
import marketer from '../../service/marketer';
import user from '../../service/user';

import menuLayout from '../../directive/menu-layout';
import fileChange from '../../directive/file-change';		

import routing from './preferences.routes';
import PreferencesController from './preferences.controller';

export default angular.module('page.preferences', [
		uirouter,

		marketer,
		brand,
		user,

		menuLayout,
		fileChange,
	])
	.config(routing)
	.controller('PreferencesController', PreferencesController)
	.name;



// WEBPACK FOOTER //
// ./src/page/preferences/index.js